import { Component, OnInit } from '@angular/core';
import { Validators, AbstractControl, ValidationErrors, AbstractControlOptions, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { CnafUserService, CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { Observable } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
import { LIBELLE_FORMULAIRE, LIBELLE_STAT, REGEX_COURRIEL } from '../constants/configlibelles';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Router } from '@angular/router';
import { context } from '../../../src/contexts/context';
import { TagXitiService } from '../services/tagxiti.service';
import { InfosCommune } from '../models/infoscommune.model';
import { Localites } from '../models/localites.model';
import { LibMotifReclamation, LibObjetMessage, LibPrestation } from '../models/libellesformulaire.model';


@Component({
  selector: 'cnaf-contacter-caf-primo-courriel',
  templateUrl: './contactercafprimocourriel.component.html',
  styleUrls: ['./contactercafprimocourriel.component.css']
})
export class ContacterCafPrimoCourrielComponent implements OnInit {

  contactMaCafPrimoForm!: FormGroup<{
    nomFamille: FormControl<string | null>,
    nomUsage: FormControl<string | null>,
    prenom: FormControl<string | null>,
    email: FormControl<string | null>,
    emailConfirm: FormControl<string | null>,
    telephone: FormControl<string | null>,
    adresse: FormControl<string | null>,
    codePostalCommune: FormControl<string | null>,
    objetMessage: FormControl<any | null>,
    motifReclamation: FormControl<any | null>,
    prestation: FormControl<any | null>,
    message: FormControl<string | null>,
    acceptCU: FormControl<boolean | null>
  }>;

  listeLocalites!: Observable<any>;
  submitted = false;
  etat!: string;
  codeOrganisme!: string;
  profilUsagersPrimo: any;
  profilConjointsNonRadies!: boolean;
  profilAmi: any;
  indicateursSite: any;
  listeObjectMessage = LIBELLE_FORMULAIRE.listeObjetMessagePrimo;
  listeMotifReclamation = LIBELLE_FORMULAIRE.listeMotifReclamation;
  listePrestation = LIBELLE_FORMULAIRE.listePrestation;
  nomCaf!: string;
  focusTitre = true;
  codePostalKO = false;
  urlRetourAccueil = '/redirect/s/Redirect?page=accueilCaffr';
  identifiantCommune = '';
  selObjetMessage: LibObjetMessage;
  selMotifReclamation: LibMotifReclamation;
  selPrestation: LibPrestation;


  constructor(private readonly formBuilder: FormBuilder,
    protected readonly cnafContacterMaCafService: CnafContacterMaCafService,
    private readonly cnafUserService: CnafUserService,
    private readonly tagXitiService: TagXitiService,
    private readonly cnafAtTagService: CnafAtTagService,
    private readonly router: Router) {
    const regExp = new RegExp('^[[A-Za-z0-9](([_\\.\\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([_\\.\\-]?[a-zA-Z0-9]+)*)\\.([A-Za-z]{2,})$');
    this.indicateursSite = {
      x11: '',
      x12: '',
      x13: ''
    };

    const pattern = /^[a-zA-Zà-ÿÀ-Ÿ '-]*$/;
    this.contactMaCafPrimoForm = this.formBuilder.group(
      {
        nomFamille: ['', {
          validators: [Validators.required, Validators.maxLength(63), Validators.pattern(pattern), this.noWhitespaceValidator],
          updateOn: 'blur'
        }],
        nomUsage: ['', {
          validators: [Validators.maxLength(28), Validators.pattern(pattern)],
          updateOn: 'blur'
        }],
        prenom: ['', {
          validators: [Validators.required, Validators.maxLength(32), Validators.pattern(pattern), this.noWhitespaceValidator],
          updateOn: 'blur'
        }],
        email: ['', {
          validators: [Validators.required, Validators.pattern(regExp)],
          updateOn: 'blur'
        }],
        emailConfirm: ['', {
          validators: [Validators.required, Validators.pattern(regExp)],
          updateOn: 'blur'
        }],
        telephone: ['', {
          validators: [Validators.required, Validators.pattern(/^\d{10}$/)],
          updateOn: 'blur'
        }],
        adresse: ['', {
          validators: [Validators.required, this.noWhitespaceValidator],
          updateOn: 'blur'
        }],
        codePostalCommune: ['', [Validators.required, Validators.minLength(3), Validators.pattern(/^[a-zA-Z0-9à-ÿÀ-Ÿ \'\-;]*$/)]],
        objetMessage: ['', [Validators.required]
        ],
        motifReclamation: [''],
        prestation: [''],
        message: ['', {
          validators: [Validators.required, this.noWhitespaceValidator],
          updateOn: 'blur'
        }],
        acceptCU: [false, [Validators.requiredTrue]]
      },
      { validator: this.emailConfirming } as AbstractControlOptions
    );

    this.selObjetMessage = new LibObjetMessage();
    this.selMotifReclamation = new LibMotifReclamation();
    this.selPrestation = new LibPrestation();


    this.fcontact.objetMessage.valueChanges.subscribe((value: any) => {
      this.selObjetMessage = value;
      if (value && !value.selectionnable) {
        this.contactMaCafPrimoForm.controls['objetMessage'].setErrors({ required: true });
      }
    });
    this.fcontact.motifReclamation.valueChanges.subscribe((value: any) => {
      this.selMotifReclamation = value;
      if (value && !value.selectionnable) {
        this.contactMaCafPrimoForm.controls['motifReclamation'].setErrors({ required: true });
      }
    });
    this.fcontact.prestation.valueChanges.subscribe((value: any) => {
      this.selPrestation = value;
      if (value && !value.selectionnable) {
        this.contactMaCafPrimoForm.controls['prestation'].setErrors({ required: true });
      }
    });
  }

  ngOnInit(): void {
    this.etat = "loading";
    if (this.cnafContacterMaCafService.logged) {
      this.urlRetourAccueil = '/redirect/s/Redirect?page=monCompte';
    }
    this.profilConjointsNonRadies = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_CONJOINTS)
      && !this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_RADIES);

    this.profilUsagersPrimo = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_USAGERS_PRIMO);
    this.profilAmi = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_AMI);
    this.codeOrganisme = this.cnafContacterMaCafService.getCodeOrgaContact(this.profilAmi, this.profilUsagersPrimo);

    if (this.codeOrganisme === undefined || this.codeOrganisme === '') {
      this.redirect('/redirect/s/Redirect?page=allocatairesMaCafRecherche');
    } else {
      const params = { codeOrga: this.codeOrganisme };
      this.traitementCourrielAutoriseNonAuth(params);
      const tagObj = this.tagXitiService.getAtTagObject('contactcafprimocourriel', context.type, 'contactermacaf', '', '');
      this.cnafAtTagService.pageSend(tagObj);
    }
  }

  // champ codePostalCommune : si on quitte le champ on récupere l'item selectionné
  // si aucun item selectionné au survol de la liste (bug bootstrap), on déclennche une érreur
  codePostalOnBlur(event: TypeaheadMatch): void {
    if (!event) {
      this.codePostalKO = true;
    }
    else {
      this.fcontact.codePostalCommune.setValue(event.value);
      this.identifiantCommune = event.item.identifiantCommune;
    }
  }
  codePostalOnSelect(event: TypeaheadMatch): void {
    this.identifiantCommune = event.item.identifiantCommune;
  }
  // liste des communes vide , activé seulement à partir du typeaheadMinLength.
  codePostalNoResult(noresult: boolean): void {
    this.codePostalKO = noresult;
  }


  // on provoque une érreur si emailConfirm est différent de email et sil il n y a pas une autre érreur
  emailConfirming(form: FormGroup): ValidationErrors | null {
    if (form) {
      return (form.controls.email.value !== form.controls.emailConfirm.value && !(form.controls.emailConfirm.errors)) ? { mismatch: true } : null;
    }
    return null;
  }

  // on provoque une érreur si que des espaces sont présent
  noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    if (control) {
      return (control.value.length > 0 && control.value.trim().length === 0) ? { pattern: true } : null;
    }
    return null;
  }


  // accesseur champs
  get fcontact() { return this.contactMaCafPrimoForm.controls; }

  // redirection sur bouton quitter
  redirect(url: string): void {
    window.location.href = url;
    window.scrollTo(0, 0);
  }

  // Contrôle que l'adresse mail et l'adresse mail de confirmation sont identiques
  emailsMatch(email: AbstractControl, emailConfirm: AbstractControl) {
    return email.valid && emailConfirm.valid && email !== undefined && emailConfirm !== undefined && email.value === emailConfirm.value;
  }

  // Soumission de l'enregistrement du courriel primo
  envoyer(): void {
    this.submitted = true;

    this.setDonneesContactDepuisForm();

    if (this.fcontact.nomFamille.valid && this.fcontact.prenom.valid && this.fcontact.nomUsage.valid &&
      this.emailsMatch(this.fcontact.email, this.fcontact.emailConfirm) && this.fcontact.telephone.valid && this.fcontact.adresse.valid &&
      this.fcontact.codePostalCommune.valid && !this.codePostalKO && this.fcontact.objetMessage.valid && this.fcontact.motifReclamation.valid &&
      this.fcontact.prestation.valid && this.fcontact.message.valid && this.fcontact.acceptCU.value === true) {

      this.etat = 'loading';

      /* Nettoyage des champs saisis */

      const { commune, message, nomUsage, nomFamille, prenom, adresse, codePostal } = this.nettoyageChampsSaisis();
      if (!commune) {
        this.contactMaCafPrimoForm.controls['codePostalCommune'].setErrors({ required: true });
        this.etat = 'loaded';
        return;
      }


      const data = {
        msg: message,
        adresseEmail: this.fcontact.email.value,
        nomUsage: (this.cnafContacterMaCafService.isUndefOrNull(nomUsage) || nomUsage === '') ? nomFamille : nomUsage,
        nomFamille,
        prenom,
        numeroTel: this.fcontact.telephone.value,
        adresse,
        codePostal,
        commune,
        nomCaf: this.nomCaf,
        codeOrga: this.codeOrganisme,
        objetMessage: (this.cnafContacterMaCafService.isUndefOrNull(this.selObjetMessage)) ? null : this.selObjetMessage.code,
        motifReclamation: (this.cnafContacterMaCafService.isUndefOrNull(this.selMotifReclamation)) ? null : this.selMotifReclamation.code,
        prestation: (this.cnafContacterMaCafService.isUndefOrNull(this.selPrestation)) ? null : this.selPrestation.code,
        idSousMotifMessage: (this.cnafContacterMaCafService.isUndefOrNull(this.selObjetMessage)) ? null : this.cnafContacterMaCafService
          .getRnProduct(this.selObjetMessage.code)
      };

      this.envoiDuForm(data, codePostal);
      window.scrollTo(0, 0);
    }
  }

  private envoiDuForm(data: { msg: string; adresseEmail: string | null; nomUsage: string; nomFamille: string; prenom: string; numeroTel: string | null; adresse: string; codePostal: string; commune: string; nomCaf: string; codeOrga: string; objetMessage: string | null; motifReclamation: string | null; prestation: string | null; idSousMotifMessage: string | null; }, codePostal: string) {
    if (data.codeOrga === 'null') {
      // Personnes qui se connectent mais qui n'ont pas de codeorga ni codeorgacreationcompte
      // cf. mail "Problème courriels avec code orga null" du 20/10/2022 18:37
      this.cnafContacterMaCafService.getInfosCommune(codePostal, this.identifiantCommune).subscribe({
        next: (infosCommune: InfosCommune) => {
          data.codeOrga = infosCommune.codeOrga;
          this.postForm(data);
        },
        error: () => {
          this.postFormKo();
        }
      });
    } else {
      this.postForm(data);
    }
  }

  private nettoyageChampsSaisis() {
    const nomUsage = this.stringSanitize(this.fcontact.nomUsage.value!);
    const nomFamille = this.stringSanitize(this.fcontact.nomFamille.value!);
    const prenom = this.stringSanitize(this.fcontact.prenom.value!);
    const adresse = this.stringSanitize(this.fcontact.adresse.value!);
    const message = this.stringSanitize(this.fcontact.message.value!);
    const codePostal = this.fcontact.codePostalCommune.value!.substring(0, 5);
    const commune = this.fcontact.codePostalCommune.value!.substring(5).trim();
    return { commune, message, nomUsage, nomFamille, prenom, adresse, codePostal };
  }

  private setDonneesContactDepuisForm() {
    this.fcontact.nomFamille.setValue(this.fcontact.nomFamille.value!.trim());
    if (this.fcontact.nomUsage.value) {
      this.fcontact.nomUsage.setValue(this.fcontact.nomUsage.value.trim());
    }
    this.fcontact.prenom.setValue(this.fcontact.prenom.value!.trim());
    this.fcontact.adresse.setValue(this.fcontact.adresse.value!.trim());
    this.fcontact.message.setValue(this.fcontact.message.value!.trim());
  }

  postForm(data: any): void {
    this.cnafContacterMaCafService.postForm(
      data
    ).subscribe({
      next: (datab: any) => {
        this.postFormOk(datab);
      },
      error: () => {
        this.postFormKo();
      }
    });
  }

  postFormOk(response: any): void {

    this.indicateursSite.x11 = this.selObjetMessage.code;
    const tagObj = this.tagXitiService.getAtTagObject(LIBELLE_STAT.libelleEnvoiPrimo, context.type, this.codeOrganisme, LIBELLE_STAT.libelleContacterMaCaf,
      LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
    this.cnafAtTagService.pageSend(tagObj);
    let rnProductSelected = '';
    const selectedProduct = (this.cnafContacterMaCafService.isUndefOrNull(this.selObjetMessage)) ? null : this.cnafContacterMaCafService
      .getRnProduct(this.selObjetMessage.code);
    if (selectedProduct) {
      const res = selectedProduct.split('_');
      if (res[2]) {
        rnProductSelected = `SOUSMOTIF=${res[2]}`;
      }
    }
    this.cnafContacterMaCafService.statsSidAccesRubrique(rnProductSelected, this.selObjetMessage.statSid);
    this.etat = 'postFormOk';
  }

  postFormKo() {
    this.indicateursSite.x4 = '1';
    this.indicateursSite.x11 = this.selObjetMessage.code;
    const tagObj = this.tagXitiService.getAtTagObject(LIBELLE_STAT.libelleEnvoiPrimo, context.type, this.codeOrganisme, LIBELLE_STAT.libelleContacterMaCaf,
      LIBELLE_STAT.libelleParCourriel, null, this.indicateursSite);
    this.cnafAtTagService.pageSend(tagObj);
    this.etat = 'postFormKo';
  }

  /* Supprime les caractères parasites qui ont pu être saisis */
  // Suppression Unicode "Control Characters"
  // Sauf LF,CR,Horizontal TAB
  stringSanitize(valeur: string): string {
    if (valeur !== undefined) {
      return valeur.replace(REGEX_COURRIEL.value, '');
    } else {
      return '';
    }
  }

  traitementCourrielAutoriseNonAuth(params: any): void {
    this.cnafContacterMaCafService.getCourrielAutoriseNonAuth(params).subscribe(
      {
        next: (data: any) => {
          if (data.courrielAutorise && !this.profilConjointsNonRadies) {
            this.cnafContacterMaCafService.statsSidAccesRubrique('', 'ACCDIAWEB');

            this.listeLocalites = new Observable((observer: any) => {
              observer.next(this.fcontact.codePostalCommune.value);
            }).pipe(mergeMap((token: any) =>
              this.cnafContacterMaCafService.getLocalites(token, 'FRA').pipe(map((res: Localites) => {
                res.listRechLoc.forEach((v, i, a) => {
                  const values = a[i].lib.split(';');
                  let cpEtVille = values[0]; // cp et ville
                  if (values.length === 2) { // présence lieudit
                    const cp = cpEtVille.split(' ').shift(); // cp
                    cpEtVille = cp + ' ' + values[1];
                  }
                  a[i].lib = cpEtVille;
                });
                res.listRechLoc = res.listRechLoc.filter((v, i, a) => a.findIndex(t => t.lib === v.lib) === i);
                return res.listRechLoc;
              }))));

            /* Récupération des informations de la Caf */
            this.nomCaf = this.cnafContacterMaCafService.getNomCaf();
            this.etat = "loaded";
          }
          else {
            this.etat = 'nonAutorise';
          }
        },
        error: () => {
          this.etat = 'error';
        }
      }
    );
  }
  confirmerClick() {
    const message = "Confirmez-vous l'abandon de l'envoi de votre message ?";
    if (confirm(message)) {
      this.redirect('/redirect/s/Redirect?page=maCafContactCaf#/contactcaf');
    }
  }

}
